"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapReportViewCountAndDate = exports.syncViewCountAndDate = exports.getRecent = void 0;
const internalAxios_1 = require("./internalAxios");
const getRecent = async (reportType) => {
    const { data } = await internalAxios_1.internalAxios.get(`/api/recent/${reportType}`);
    return data;
};
exports.getRecent = getRecent;
const syncViewCountAndDate = async (reportType, reports, recentlyViewedReports) => {
    if (!recentlyViewedReports || recentlyViewedReports.length < 1) {
        recentlyViewedReports = await (0, exports.getRecent)(reportType);
    }
    if (recentlyViewedReports.length < 1) {
        return reports;
    }
    return (0, exports.mapReportViewCountAndDate)(reports, recentlyViewedReports);
};
exports.syncViewCountAndDate = syncViewCountAndDate;
const mapReportViewCountAndDate = (reports, recentlyViewedReports) => {
    reports.forEach((report) => {
        const recent = recentlyViewedReports.find((recentReport) => recentReport.reportId === report.id.toString());
        if (recent) {
            report.lastViewedAt = new Date(recent.utcLastModifiedDate);
        }
        report.viewCount = recent?.viewCount ?? 0;
    });
    return reports;
};
exports.mapReportViewCountAndDate = mapReportViewCountAndDate;
